import { render, staticRenderFns } from "./StandByListBoard.vue?vue&type=template&id=641a5747&scoped=true"
import script from "./StandByListBoard.vue?vue&type=script&lang=js"
export * from "./StandByListBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641a5747",
  null
  
)

export default component.exports